export const FETCH_PRODUCT_GLOBAL_LIMIT_LOADING =
	'FETCH_PRODUCT_GLOBAL_LIMIT_LOADING';
export const FETCH_PRODUCT_GLOBAL_LIMIT_SUCCESS =
	'FETCH_PRODUCT_GLOBAL_LIMIT_SUCCESS';
export const FETCH_PRODUCT_GLOBAL_LIMIT_ERROR =
	'FETCH_PRODUCT_GLOBAL_LIMIT_ERROR';
